module.exports = __webpack_public_path__ + "img/interview@2x.8acaedb.png";